import React, { useState, useRef, Fragment } from 'react';
import styled from 'styled-components';
import { ChevronLeft } from '@styled-icons/bootstrap/ChevronLeft';
import { ChevronRight } from '@styled-icons/bootstrap/ChevronRight';
import { useHasOverflow, useImpactClaims } from 'hooks';
import { convertHexToRGBA } from 'utils/color';
import { ImpactClaimTitle } from 'components/Shared/ImpactClaims';
const StyledContainer = styled.div `
  position: relative;
  overflow: visible;
  background-color: ${({ backgroundColor }) => backgroundColor};
  max-width: fit-content;
`;
const ClaimsContainer = styled.div `
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  padding: 12px 8px 0;
  margin-left: 0;
  margin-bottom: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;
const ArrowButton = styled.button `
  position: absolute;
  top: 16px;
  border: 0;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.11);
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  cursor: pointer;

  ${({ backButton }) => (backButton ? `left: 0;` : `right: 0;`)}

  svg {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
const FadeOut = styled.div `
  position: absolute;
  bottom: 0;
  right: -1px;
  display: block !important;
  width: 100px;
  height: 100%;
  background: linear-gradient(
    to right,
    ${({ backgroundColor }) => convertHexToRGBA(backgroundColor, 0)},
    ${({ backgroundColor }) => convertHexToRGBA(backgroundColor, 1)} 100%
  );
  pointer-events: none;
`;
const FadeIn = styled.div `
  position: absolute;
  bottom: 0;
  left: -1px;
  display: block !important;
  width: 100px;
  height: 100%;
  background: linear-gradient(
    to left,
    ${({ backgroundColor }) => convertHexToRGBA(backgroundColor, 0)},
    ${({ backgroundColor }) => convertHexToRGBA(backgroundColor, 1)} 100%
  );
  pointer-events: none;
`;
const ImpactClaimsSlider = ({ backgroundColor = '#fff', isMobile = false, displayVerifiedText = false, }) => {
    const { selectedClaimId, impactClaims, toggleImpactClaim } = useImpactClaims();
    const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
    const containerRef = useRef();
    const { hasOverflow } = useHasOverflow(containerRef);
    const scroll = (scrollOffset = 100) => {
        if (containerRef.current) {
            // when pressing arrow button scroll 100px in that direction
            // set current scroll position to know when to display arrow button
            // @ts-ignore
            containerRef.current.scrollLeft += scrollOffset;
            setCurrentScrollPosition(containerRef.current.scrollLeft + scrollOffset);
        }
    };
    if (!impactClaims.edges.length)
        return null;
    return (React.createElement(StyledContainer, { backgroundColor: backgroundColor, id: "st-claims-slider" },
        hasOverflow && !isMobile && (React.createElement(Fragment, null,
            React.createElement(ArrowButton, { onClick: () => scroll(100), id: "st-claims-next-button" },
                React.createElement(ChevronRight, { size: 20 })),
            currentScrollPosition > 0 && (React.createElement(Fragment, null,
                React.createElement(ArrowButton, { backButton: true, onClick: () => scroll(-100), id: "st-claims-previous-button" },
                    React.createElement(ChevronLeft, { size: 20 })),
                React.createElement(FadeIn, { backgroundColor: backgroundColor, id: "st-claims-fade-in" }))),
            React.createElement(FadeOut, { backgroundColor: backgroundColor, id: "st-claims-fade-out" }))),
        React.createElement(ClaimsContainer, { ref: containerRef, isMobile: isMobile, displayVerifiedText: displayVerifiedText, id: "st-claims-list" }, impactClaims.edges.map((impactClaim) => (React.createElement(ImpactClaimTitle, { key: impactClaim.node.id, onClaimClick: () => toggleImpactClaim(impactClaim.node.id), impactClaim: impactClaim.node, active: selectedClaimId === impactClaim.node.id, renderedOnImpactSlider: true }))))));
};
export default ImpactClaimsSlider;
